export const parseGuestEmail = (cartOrOrder: Record<string, any>) => {
  const matches = cartOrOrder.user.uid.match(/^([a-zA-Z0-9-]+)\|(.+)$/) as Array<string>;

  if (!matches || matches.length !== 3) {
    return null;
  }

  return matches[2];
};
